import { createFeatureSelector, createSelector } from '@ngrx/store'
import { SettingsState } from '../state/settings.state'

const getSettingsState = createFeatureSelector<SettingsState>('settings')

export const getCommunicationPreferencesFromSettings = () =>
  createSelector(getSettingsState, state => {
    return state?.communicationPreferences
  })
